module.exports = __webpack_public_path__ + "img/PUBLIC_SQUARE.6297678b.png";